import requestFunctions from "../../functions/requestFunctions";


export const state = {
  UNITS_ITEM: {},
  UNITS_LIST: [],
  UNITS_TABLE_DATA: [],
  UNITS_ARRAY_DATA: [],
  UNITS_TOTAL_ROWS: 0
}

export const getters = {
  GET_UNITS_ITEM: (state) => {
    return state.UNITS_ITEM;
  },
  GET_UNITS_LIST: (state) => {
    return state.UNITS_LIST;
  },
  GET_UNITS_TABLE_DATA: (state) => {
    return state.UNITS_TABLE_DATA;
  },
  GET_UNITS_ARRAY_DATA: (state) => {
    return state.UNITS_ARRAY_DATA;
  },
  GET_UNITS_TOTAL_ROWS: (state) => {
    return state.UNITS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_UNITS_ITEM(state, item) {
    state.UNITS_ITEM = item;
  },

  UPDATE_UNITS_LIST(state, list) {
    
    state.UNITS_LIST = list.data;

    state.UNITS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.UNITS_TABLE_DATA = [];
    state.UNITS_ARRAY_DATA = [];

    list.forEach(el => {

      state.UNITS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'code' : el.code,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.UNITS_ARRAY_DATA.push({
        id: el.id,
        name: el.name,
        code: el.code,
        uuid: el.uuid,
      });
    });
  },
}

export const actions = {

  async FETCH_UNITS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/units/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_UNITS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_UNITS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/units';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_UNITS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_UNITS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/units';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_UNITS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/units/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_UNITS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/units/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}